import { getEmployeeMediasByEmployerId } from '../../API/Services/RemuneracionVariable/EmployeeMedia'
import { getEvaluationList } from '../../API/Employee/Employee'
import CarouselAvaliation from '../../Components/EmployeeEvaluation/carouselAvaliation'
import Loading from '../../Components/Loading/Loading'
import { useCallback, useEffect, useState } from 'react'
import { MediasAccordion } from '../../Components/EmployeeEvaluation/mediasCriterions'

export function EmployeePerformance() {
	const companyId = JSON.parse(localStorage.getItem('user')).companyId
	const userId = JSON.parse(localStorage.getItem('user')).id
	const [loading, setLoading] = useState(false)

	const [evaluations, setEvaluations] = useState([])
	const [selectedEvaluation, setSelectedEvaluation] = useState(null)
	const [evaluationId, setEvaluationId] = useState(0)

	const [medias, setMedias] = useState()

	const fetchData = useCallback(async () => {
		setLoading(true)

		try {
			const { rows: evaluationsFromAPI } = await getEvaluationList(companyId)
			setEvaluations(evaluationsFromAPI)

			const hasEvaluations = evaluationsFromAPI.length > 0

			if (hasEvaluations) {
				const fallbackIndex = evaluationsFromAPI.length - 1
				const currentIndex = selectedEvaluation ?? fallbackIndex
				const evaluationId = evaluationsFromAPI[currentIndex]?.id

				setEvaluationId(evaluationId)
				setSelectedEvaluation(currentIndex)

				if (evaluationId) {
					const respMedias = await getEmployeeMediasByEmployerId(userId, evaluationId)
					setMedias(respMedias)
				}
			}
		} catch (error) {
			console.error('Erro ao buscar avaliações:', error)
		} finally {
			setLoading(false)
		}
	}, [companyId, selectedEvaluation, userId])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	return (
		<>
			{loading ? (
				<Loading />
			) : (
				<div>
					<div className='tw-flex tw-justify-between tw-items-center tw-mb-4 tw-pr-20'>
						<div>
							<h3 className='tw-mb-4 tw-font-bold'>Evaluación de Performance y Potencial</h3>
							{/* <div className='tw-text-lg tw-mb-4 tw-pr-20'>Alguma descriçao</div> */}
						</div>
					</div>

					<div className='tw-rounded-xl tw-shadow-md tw-p-6 border tw-mr-20'>
						<div className='tw-mb-5'>
							<CarouselAvaliation evaluations={evaluations} setSelectedEvaluation={setSelectedEvaluation} selectedEvaluation={selectedEvaluation} />
						</div>

						<div className='tw-text-purple-600'>
							<MediasAccordion medias={medias} userId={userId} />
						</div>
					</div>
				</div>
			)}
		</>
	)
}
